import { ReactNode, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { SessaoARDoResponsavel } from "../../../../../Models/Domain/AreaRestrita/Sessao";
import { SessaoARContext } from "../../../../Contexts/SessaoContext";
import { TypeAluno } from "../../../../../Models/Domain/Pessoa/Aluno";
import { ISelectComPesquisaProps, SelectComPesquisa } from "../../../../../Components/SelectComPesquisa";
import { Button, Col, Divider, Flex, Form, notification, Row } from "antd";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { PropriedadesDeNotificacao } from "../../../../../Utils/Notificacoes";
import { CadastroDeAluno } from "../../../../../Views/Viagem/Cadastros/Viagem/Componentes/CadastroDeAluno";
import AlunoModalFormChange from "./AlunoModalFormChange";
import { useListarAlunoDoResponsavel } from "../../../../../Services/Pessoa/AlunoResponsavelServices";
import { extractorNomePessoa } from "@/Models/Pessoa/Pessoa";

interface IAlunosSelectProps extends Omit<ISelectComPesquisaProps, "onChange" | "value"> {
    /**
     * @default true
     */
    permiteAlterarAluno?:boolean;
    /** @default false */
    permiteCadastrarNovoAluno?:boolean;
    label?:ReactNode;
    onChange?:(aluno:TypeAluno|null) => void;
    value?:TypeAluno|null;
}
type FormType = {
    aluno:TypeAluno|null;
}
export function AlunoSelect({
    permiteAlterarAluno,
    permiteCadastrarNovoAluno,
    label,
    onChange,
    value,
    ...rest
}:IAlunosSelectProps) {
    permiteAlterarAluno = permiteAlterarAluno ?? true;
    permiteCadastrarNovoAluno = permiteCadastrarNovoAluno ?? false;

    label = label === undefined ? "Aluno" : label;

    const [formulario] = Form.useForm<FormType>();
    const sessaoContext = useContext(SessaoARContext);
    const [ novoAluno, setNovoAluno ] = useState<TypeAluno|null>(null);
    const [open, setOpen] = useState(false);

    const {
        data,
        isLoading
    } = useListarAlunoDoResponsavel({
        selectAfter(data) {
            // sessaoContext?.setSessao(prev => {
            //     return {
            //         ...prev,
            //         info : {
            //             ...(prev?.info ?? {} as any),
            //             alunos : data
            //         }
            //     }
            // });

            return data;
        }
    });

    const alunos = useMemo(() => {
        const cadastrados = data?.sort((a, b) => extractorNomePessoa(a.aluno.pessoa!).localeCompare(extractorNomePessoa(b.aluno.pessoa!))).map(m => m.aluno) ?? [];
        if (novoAluno != null) cadastrados.push(novoAluno);
        return cadastrados.sort((a, b) => extractorNomePessoa(a.pessoa!).localeCompare(extractorNomePessoa(b.pessoa!))) as TypeAluno[];
    }, [novoAluno, data]);

    useEffect(() => { 
        const aluno = alunos.find(f => f.codigo == value?.codigo) ?? null;
        if (aluno != null)
            formulario.setFieldsValue({
                aluno
            });
    }, [value?.codigo]);
    
    
    return <>
        <Form<FormType>
            form={formulario}
            component={"div"}
            layout='vertical' 
            autoComplete='off'
        >
            <Col xs={24} sm={24} md={12} lg={9} xl={8} xxl={6}>
                <Flex justify="space-between" align="end" wrap="wrap" gap={8}>
                    <Form.Item<FormType> 
                        name={["aluno", "codigo"]}
                        label={label} 
                        style={{ 
                            flexGrow : 1,
                            marginBottom : "0px"
                        }}
                        {...rest}
                    >
                        <SelectComPesquisa
                            {...rest}
                            loading={isLoading}
                            options={alunos.map(m => {
                                return {
                                    value : m.codigo,
                                    label : extractorNomePessoa(m.pessoa!)
                                };
                            })}
                            value={value?.codigo}
                            onChange={(value) => {
                                onChange?.(alunos.find(f => f.codigo === value) ?? null);
                            }}
                            style={{ width : "100%" }}
                            allowClear
                            placeholder={"Selecione um aluno"}
                            open={open}
                            onDropdownVisibleChange={(visible) => setOpen(visible)}
                        ></SelectComPesquisa>
                    </Form.Item>
                    {
                        permiteCadastrarNovoAluno && <AlunoModalFormChange 
                            width={"80vw"}
                            aluno={novoAluno == null ? undefined : novoAluno}
                            onChange={(aluno) => {
                                if (aluno != null) {
                                    aluno.codigo = -1; // Novo cadastro
                                    setNovoAluno(aluno);
                                    formulario.setFieldsValue({
                                        aluno
                                    });
                                    onChange?.(aluno);
                                }
                            }}
                            onOpen={() => {
                                setOpen(false);
                            }}
                            buttonOpen={<Button
                                type="primary" 
                                title="Clique aqui para adicionar um novo aluno"
                                icon={novoAluno != null ? <EditOutlined /> : <PlusOutlined />}
                            >
                                Adicionar um novo aluno
                            </Button>}
                        />
                    }
                </Flex>
            </Col>
            {
                permiteAlterarAluno && <Form.Item<FormType> style={{ width : "100%" }} shouldUpdate={(anteiror, atual) => anteiror.aluno?.codigo != atual.aluno?.codigo}>
                    {
                        ({getFieldValue}) => {
                            const aluno = alunos.find(f => f.codigo == getFieldValue(["aluno", "codigo"]));
                            if (getFieldValue(["aluno", "codigo"]) > 0 && aluno != null)
                            {
                                return <Col xs={24}>
                                    <Divider>Informações do aluno {extractorNomePessoa(aluno.pessoa!)}</Divider>
                                    <CadastroDeAluno
                                        privilegio="responsavel"
                                        alunoEmAlteracao={aluno} 
                                        notificar={false}
                                        limparFormularioAoFinalizar={false}
                                        depoisDeFinalizar={() => {
                                            const intervaloSeg = 2;
            
                                            const mensagem: JSX.Element = <> Aluno atualizado com sucesso. </>
            
                                            notification.open({
                                                ...PropriedadesDeNotificacao.Sucesso(mensagem),
                                                duration: intervaloSeg
                                            });
                                        }}
                                    />
                                </Col>;
                            }
                        }
                    }
                </Form.Item>
            }
        </Form>
    </>;
}